export const PROVIDERS = {
  1: 'SMS',
  2: 'EMAIL',
  3: 'WHATSAPP',
  4: 'SMSAWS',
} as const;

export type providers = 'SMS' | 'EMAIL' | 'WHATSAPP' | 'SMSAWS' | 'QR';
